/**
 * 视觉刷新主题（2026-06）：
 * - 从冷色调（深绿 #1A2B3C + 荧光绿 #AAFF45）换成暖紫 + 琥珀
 * - 全局更大的圆角，更圆润
 * - 主字体 Inter，代码字体 JetBrains Mono
 */
import type { ThemeConfig } from "antd";

export const PRIMARY = "#7C3AED";      // 紫罗兰
export const ACCENT  = "#F59E0B";      // 琥珀
export const SUCCESS = "#10B981";      // 翠绿
export const DANGER  = "#EF4444";      // 鲜红
export const INFO    = "#06B6D4";      // 青绿

export const SURFACE_BG = "#FAF7FF";   // 浅紫白
export const CARD_BG = "#FFFFFF";

export const theme: ThemeConfig = {
  token: {
    colorPrimary: PRIMARY,
    colorInfo: INFO,
    colorSuccess: SUCCESS,
    colorWarning: ACCENT,
    colorError: DANGER,
    colorLink: PRIMARY,
    colorBgLayout: SURFACE_BG,
    borderRadius: 12,
    borderRadiusLG: 16,
    borderRadiusSM: 8,
    fontFamily: "'Inter', 'PingFang SC', 'Microsoft YaHei', sans-serif",
    fontSize: 14,
    boxShadow: "0 4px 12px rgba(124, 58, 237, 0.08)",
    boxShadowSecondary: "0 8px 24px rgba(124, 58, 237, 0.12)",
  },
  components: {
    Button: {
      borderRadius: 12,
      controlHeight: 38,
      fontWeight: 500,
    },
    Card: {
      borderRadiusLG: 16,
      boxShadowTertiary: "0 2px 12px rgba(124, 58, 237, 0.06)",
    },
    Menu: {
      itemBorderRadius: 10,
      activeBarBorderWidth: 0,
      itemSelectedBg: "rgba(124, 58, 237, 0.10)",
      itemSelectedColor: PRIMARY,
    },
    Input: {
      borderRadius: 10,
      controlHeight: 38,
    },
    Tag: {
      borderRadiusSM: 8,
    },
    Modal: {
      borderRadiusLG: 16,
    },
  },
};
